import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from './index.scss'

const SearchRow = ({ href, children, className, onClick }) => (
  <a
    href={href}
    className={classNames(style.searchRow, className)}
    onClick={onClick}
  >
    {children}
  </a>
)

SearchRow.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default SearchRow
